import schema from '../../TransferirBeneficiario/Beneficiario/schema';

import { cloneObject } from '../../../../utils';

function transferir(form) {
    const dadosForm = cloneObject(schema);

    dadosForm.carteirinha = form.busca.carteirinha;
    dadosForm.novoContrato.value = form.form.codTsContratoNovo;

    return dadosForm;
}

export { transferir };
